import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { annonceService, sousServiceService } from '../../../api';
import './ajoutAnnonce.css';

const AjoutAnnonce = () => {
  const navigate = useNavigate();
  const [annonce, setAnnonce] = useState({
    titre: '',
    description: '',
    type_annonce: 'offre',
    prix: '',
    ville: '',
    sous_service_id: '',
    image: null
  });
  const [sousServices, setSousServices] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Récupération des sous-services
  useEffect(() => {
    const fetchSousServices = async () => {
      try {
        const response = await sousServiceService.getAll();
        setSousServices(response.data || response);
      } catch (error) {
        console.error('Erreur lors du chargement des sous-services:', error);
      }
    };

    fetchSousServices();
  }, []); // Ajout du tableau de dépendances vide pour exécuter une seule fois

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnnonce(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setAnnonce(prev => ({ ...prev, image: e.target.files[0] }));
  };

  const validate = () => {
    const newErrors = {};
    if (!annonce.titre) newErrors.titre = 'Le titre est requis';
    if (!annonce.description) newErrors.description = 'La description est requise';
    if (!annonce.ville) newErrors.ville = 'La ville est requise';
    if (!annonce.prix) newErrors.prix = 'Le prix est requis';
    if (annonce.prix && isNaN(annonce.prix)) newErrors.prix = 'Le prix doit être un nombre';
    if (!annonce.sous_service_id) newErrors.sous_service_id = 'Le sous-service est requis';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) return;
    
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('titre', annonce.titre);
      formData.append('description', annonce.description);
      formData.append('type_annonce', annonce.type_annonce);
      formData.append('prix', annonce.prix);
      formData.append('ville', annonce.ville);
      formData.append('sous_service_id', annonce.sous_service_id);
      if (annonce.image) {
        formData.append('image', annonce.image);
      }

      await annonceService.create(formData);
      
      navigate('/annonces', { state: { success: 'Annonce créée avec succès' } });
    } catch (error) {
      console.error('Erreur complète:', error.response?.data);
      setErrors({
        submit: error.response?.data?.message || 'Une erreur est survenue lors de la création',
        ...error.response?.data?.errors,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="annonce-form-container">
      <div className="annonce-form-header">
        <h1>Créer une nouvelle annonce</h1>
        <Link to="/admin/annonces" className="btn-secondary">
          Retour à la liste
        </Link>
      </div>

      <form onSubmit={handleSubmit} className="annonce-form" encType="multipart/form-data">
        {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}
        
        <div className="form-group">
          <label>Titre *</label>
          <input
            type="text"
            name="titre"
            value={annonce.titre}
            onChange={handleChange}
            className={errors.titre ? 'is-invalid' : ''}
          />
          {errors.titre && <div className="invalid-feedback">{errors.titre}</div>}
        </div>

        <div className="form-group">
          <label>Description *</label>
          <textarea
            name="description"
            value={annonce.description}
            onChange={handleChange}
            rows="5"
            className={errors.description ? 'is-invalid' : ''}
          ></textarea>
          {errors.description && <div className="invalid-feedback">{errors.description}</div>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Type d'annonce *</label>
            <select
              name="type_annonce"
              value={annonce.type_annonce}
              onChange={handleChange}
            >
              <option value="offre">Offre</option>
              <option value="demande">Demande</option>
            </select>
          </div>

          <div className="form-group">
            <label>Prix (€) *</label>
            <input
              type="text"
              name="prix"
              value={annonce.prix}
              onChange={handleChange}
              className={errors.prix ? 'is-invalid' : ''}
            />
            {errors.prix && <div className="invalid-feedback">{errors.prix}</div>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Ville *</label>
            <input
              type="text"
              name="ville"
              value={annonce.ville}
              onChange={handleChange}
              className={errors.ville ? 'is-invalid' : ''}
            />
            {errors.ville && <div className="invalid-feedback">{errors.ville}</div>}
          </div>

          <div className="form-group">
            <label>Sous-service *</label>
            <select
              name="sous_service_id"
              value={annonce.sous_service_id}
              onChange={handleChange}
              className={errors.sous_service_id ? 'is-invalid' : ''}
            >
              <option value="">Sélectionnez un sous-service</option>
              {sousServices.map(service => (
                <option key={service.id} value={service.id}>
                  {service.nom}
                </option>
              ))}
            </select>
            {errors.sous_service_id && <div className="invalid-feedback">{errors.sous_service_id}</div>}
          </div>
        </div>

        <div className="form-group">
          <label>Image</label>
          <input
            type="file"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'En cours...' : 'Créer l\'annonce'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AjoutAnnonce;